<template>
  <span>
    <div v-if="showBookmark"
         class="bookmark"
         :class="{'bookmark-isef' : $isIsef}">
      <span v-if="!canView"
            class="icon"
            :data-balloon="showBalloon('Bookmark', hasSubscribed)"
            data-balloon-pos="down-right" @click.stop.prevent="canSubscribe">
        <i :class="{
              subcribed: !hasSubscribed,
              'fa-bookmark fa' : !$isIsef || hasSubscribed,
              'fa-regular fa-bookmark': $isIsef && !hasSubscribed,
              'bookmark-icon' : !$isIsef
          }"
           aria-label="Click to bookmark project"
           tabindex="0" @keypress.enter.space="canSubscribe" />
      </span>
      <span v-else>
        <i class="fa-lock fa-solid"/>
      </span>
    </div>
    <div v-if="this.$isYSC"
         class="location">
      <span class="location_container" :class="{'location_region': isRegion}">
        <img class="location_image"
             :class="{'location_image-phone': isPhone && isHome}"
             :src="location.flag"
             :alt="location.province" />
      </span>
      <div class="is-flex">
        <span>
            {{ location.province }}
        </span>
        <span>•</span>
        <span class="location_year">
          {{ getYear }}
        </span>
      </div>
    </div>
  </span>
</template>

<script>
import auth from '@/mixins/auth'
import subscribe from '@/mixins/subscribe'
export default {
  props: {
    project: Object
  },
  mixins: [auth, subscribe],
  computed: {
    isPhone: function () {
      return (/Android|iPhone/i.test(navigator.userAgent))
    },
    isHome: function () {
      return this.$route.fullPath.includes('/home')
    },
    isRegion: function () {
      return this.$route.fullPath.includes('/region')
    },
    getYear: function () {
      return new Date(this.project.created).getFullYear()
    },
    canView: function () {
      return this.project.isLocked && !this.isLoggedIn && this.$isStories
    },
    showBookmark: function () {
      if (this.$isYSC) return false
      switch (this.$route.path) {
        case '/profile':
          return false
        case '/mine':
          return false
        default:
          return true
      }
    },
    location: function () {
      const provinceDetails = this.project.regionProject?.regionDetails?.provinceDetails
      const regionSlug = this.project.regionProject?.regionDetails?.slug
      if (regionSlug && regionSlug === 'mexico') {
        return {
          province: 'mx',
          flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FMX.jpg?alt=media&token=f06190df-eb28-4219-83e2-b55f35eea5ac'
        }
      } else if (provinceDetails) {
        switch (provinceDetails.abbr.toLowerCase()) {
          case 'ab':
            return {
              province: 'ab',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FAlberta.jpg?alt=media&token=20772ade-b426-402d-9e57-b92755885975'
            }
          case 'bc':
            return {
              province: 'bc',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FBritish_Columbia.jpg?alt=media&token=724bbe05-5b80-4219-a5b5-0a642b08bc55'
            }
          case 'mb':
            return {
              province: 'mb',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FManitoba.jpg?alt=media&token=cbc97d9c-dec0-42e1-ad3d-d3337e9cca40'
            }
          case 'on':
            return {
              province: 'on',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FOntario.jpg?alt=media&token=6f29edc5-d27e-4529-9b06-e52fd023e53f'
            }
          case 'nb':
            return {
              province: 'nb',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FNew_Brunswick.jpg?alt=media&token=6ef2ba6a-7fe4-46e2-8710-6033f4f35656'
            }
          case 'nl':
            return {
              province: 'nl',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FNewfoundland_and_Labrador.jpg?alt=media&token=8ec78662-6a6e-4af4-bd04-a69c56286e81'
            }
          case 'ns':
            return {
              province: 'ns',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FNova_Scotia.jpg?alt=media&token=6fd36a82-2bc0-498b-9768-4e8ecfde1b4f'
            }
          case 'nwt':
          case 'nt':
            return {
              province: 'nwt',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FNorthwest_Territories.jpg?alt=media&token=0f6ab725-3e54-4b81-8fa0-a2762b63547c'
            }
          case 'nu':
            return {
              province: 'nu',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FNunavut.jpg?alt=media&token=e6d95098-e08c-4b80-9222-f6b1e7de4c38'
            }
          case 'pe':
            return {
              province: 'pe',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FPrince_Edward_Island.jpg?alt=media&token=ccbf19ab-a79b-41b7-bb83-42d3842cfff9'
            }
          case 'qc':
            return {
              province: 'qc',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FQuebec.jpg?alt=media&token=cf21ca0e-2ac9-48ef-806b-f819c35b59b7'
            }
          case 'sk':
            return {
              province: 'sk',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FSaskatchewan.jpg?alt=media&token=2ea795db-2d35-4027-9831-b79f117bea6f'
            }
          case 'yt':
            return {
              province: 'yt',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FYukon.jpg?alt=media&token=dd91fd28-ca8e-4ced-8160-2006bacd88a6'
            }
          default:
            return {
              province: 'ca',
              flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FCanada.jpg?alt=media&token=36747368-a7f3-4a24-91cd-979086879f29'
            }
        }
      } else {
        return {
          province: 'ca',
          flag: 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ysc%2Fflags-lg%2FCanada.jpg?alt=media&token=36747368-a7f3-4a24-91cd-979086879f29'
        }
      }
    }
  },
  methods: {
    showBalloon: function (action, success) {
      if (success) {
        if (this.$isHeise) {
          action = 'Gemerkt'
        } else {
          action = 'Bookmarked'
        }
      }
      if (!this.isMobile) {
        if (this.$isHeise) {
          switch (this.project.type && this.project) {
            case 'discussion':
              return success ? action : this.$t('story-header.bookmark.project')
            case 'project':
              return success ? action : this.$t('story-header.bookmark.project')
            default:
              return success ? action : this.$t('story-header.bookmark.project')
          }
        }
        return success ? action : `${action} this ${this.project.type}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.location {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: .6em;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: black;
  font-weight: 400;
  font-family: $primary-font;
  @include touch {
    font-size: 0.5em;
  }
  &_container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  &_region {
    @include mobile {
      margin-top: .7rem;
    }
  }
  &_image {
    width: auto;
    height: 22px;
    @include touch {
      height: 15px;
    }
  }
  @include mobile {
    margin-top: 3px;
  }
}
.bookmark {
  position: absolute;
  z-index: 5;
  right: 1.5%;
  color: $primary;
  &-isef {
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 10px;
    right: 10px !important;
    width: 32px;
    height: 32px;
    background-color: #DDDDDD;
  }
  &-icon {
    font-size: 1.4rem;
    @include mobile {
      font-size: 1.1rem;
    }
  }
  .subcribed {
    color: var(--background-third);
  }
  bottom: 90%;
  @include tablet-only {
    bottom: 87.8%;
  }
  @include mobile {
    bottom: 89%;
  }
}
</style>
